export const REPLAY_STEPS = 1000;          // slider resolution
export const REPLAY_SWEEP_MS = 20_000;     // play walks the full span in ~20s
export const replay = {
  ready: false,
  minT: 0,
  maxT: 0,
  cutoffT: Infinity as number,      // pings with t <= cutoffT render
  playing: false,
  rafId: null as any,
  lastFrame: 0,
};
